<template>
  <v-row>
    <v-col cols="12" class="py-0">
      <!-- Procedural Subjects Table -->
      <v-row align="center" justify="start" class="pl-5">
        <v-col cols="1" class="text-right py-0">Nombre</v-col>
        <v-col
          cols="8"
          md="4"
          :class="$vuetify.breakpoint.smAndDown ? 'ml-9' : 'ml-3'"
        >
          <v-text-field
            outlined
            v-model="nombre"
            @input="getActive"
            hide-details
          />
        </v-col>
        <v-col cols="1" class="text-left">
          <v-btn v-if="!active" @click="reset" icon :disabled="filter">
            <v-img height="30" width="30" src="@/assets/filter-disabled.png" />
          </v-btn>
          <v-btn v-else @click="getSearch" icon>
            <v-img height="30" width="30" src="@/assets/filter.png" />
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="filteredItems"
        :items-per-page="getPaginacionSujetos.registrosPagina"
        hide-default-footer
        no-data-text="El registro no posee sujetos registrados"
        class="elevation-1 px-0 caption"
        :loading="getStatus.loading"
        loading-text="Cargando... Por favor espere"
      >
        <template v-if="getStatus.loading" v-slot:footer>
          <v-progress-linear
            color="primary"
            :height="3"
            indeterminate
          ></v-progress-linear>
        </template>
      </v-data-table>
      <div class="mt-8 text-center" v-if="!getStatus.loading">
        <Pagination />
      </div>
    </v-col>
  </v-row>
</template>
<script>
import axios from "@/config/axios";
import { mapGetters } from "vuex";
import Pagination from "@/components/process/Pagination";

export default {
  components: {
    Pagination,
  },
  data: () => ({
    nombre: "",
    active: true,
    filter: false,
    filteredLocally: false,
    filterLocal: [],
    headers: [
      {
        text: "Tipo",
        value: "tipoSujeto",
        class:
          "grey--text text--darken-3 body-1 font-weight-bold blue-grey lighten-5",
        align: "left",
        // width: 300,
        sortable: false,
      },
      // {
      //   text: 'Identificación',
      //   value: 'identificacion',
      //   class: 'grey--text text--darken-3 body-1 font-weight-bold blue-grey lighten-5',
      //   align: 'left',
      //   // width: 500,
      //   sortable: false
      // },
      {
        text: "Nombre o Razón Social",
        value: "nombreRazonSocial",
        class:
          "grey--text text--darken-3 body-1 font-weight-bold blue-grey lighten-5",
        align: "left",
        sortable: false,
      },
    ],
  }),
  computed: {
    ...mapGetters("process", [
      "getPaginaActualSujetos",
      "getPaginacionSujetos",
      "getSujetos",
      "getStatus",
      "getTab",
    ]),
    filteredItems() {
      if (
        this.getPaginacionSujetos.cantidadPaginas == 1 &&
        this.filteredLocally
      ) {
        return this.filterLocal;
      } else {
        return this.getSujetos;
      }
    },
  },
  beforeDestroy() {
    this.$store.dispatch("process/setPaginaSujetos", 1);
  },
  watch: {
    getPaginaActualSujetos(pagina) {
      this.$store.dispatch("process/sujetos", {
        id: this.$route.params.id,
        nombre: this.nombre,
        tab: this.getTab,
      });
    },
  },
  methods: {
    async setPaginaSujetos() {
      await this.$store.dispatch("process/sujetos", {
        id: this.$route.params.id,
        tab: this.getTab,
      });
    },
    getActive() {
      this.active = true;
    },
    async getSearch() {
      if (this.active) {
        if (this.getPaginacionSujetos.cantidadPaginas == 1) {
          this.filteredLocally = true;
          this.filterLocal = this.getSujetos.filter((item) => {
            return item.nombreRazonSocial
              .toUpperCase()
              .includes(this.nombre.toUpperCase());
          });
        } else {
          this.filteredLocally = false;
          this.$store.dispatch("process/setPaginaSujetos", 1);
          await this.$store.dispatch("process/sujetos", {
            id: this.$route.params.id,
            nombre: this.nombre,
            tab: this.getTab,
          });
        }
        this.active = false;
        this.filter = false;
      }
    },
    reset() {
      this.getActive();
      this.nombre = "";
      this.filter = true;
      if (this.filteredLocally) {
        this.filterLocal = this.getSujetos;
      } else {
        this.$store.dispatch("process/sujetos", {
          id: this.$route.params.id,
          nombre: this.nombre,
          tab: this.getTab,
        });
        this.$store.dispatch("process/setPaginaSujetos", 1);
      }
    },
  },
};
</script>